module.exports = __webpack_public_path__ + "static/media/GoldenRules3-6.8cd6b947.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/GoldenRules3-6.svg
// module id = 758
// module chunks = 0